// =========================================================
// * Vuetify Material Dashboard PRO - v1.0.3
// =========================================================
//
// * Product Page: https://www.creative-tim.com/product/vuetify-material-dashboard-pro
// * Copyright 2019 Creative Tim (https://www.creative-tim.com)
//
// * Coded by Creative Tim
//
// =========================================================
//
// * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

import Vue from 'vue'
import App from './App.vue'
import { router } from './router'
import store from './store'
import './plugins/base'
import './plugins/chartist'
import './plugins/vee-validate'
/*
*****************************************************************************
*File :main.js
*Module : Dashboard Frontend
*Purpose :Main vuue js file for rendring the application
*Author : UI Team
*Copyright : Copyright 2021, Lab to Market Innovations Private Limited
*****************************************************************************
*/

import vuetify from './plugins/vuetify'
import i18n from './i18n'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify-daterange-picker/dist/vuetify-daterange-picker.css'
import 'font-awesome/css/font-awesome.min.css'
import ApexCharts from 'apexcharts'
import VueApexCharts from 'vue-apexcharts'
import idleVue from 'idle-vue'
 
const eventsHub = new Vue()
Vue.config.productionTip = false
Vue.use(VueApexCharts)
Vue.use(idleVue, {
  eventEmitter: eventsHub,
  store,
  idleTime: 3000, // 3 seconds,
  startAtIdle: false,
})
Vue.component('apexchart', VueApexCharts)
Vue.config.devtools = false
new Vue({
  router,
  store,
  vuetify,
  i18n,
  iconfont: 'mdi',
  render: h => h(App)
}).$mount('#app')
